import React from 'react'
import ReactSelect from 'react-select'

const Select = (props) => {
  return (
    <ReactSelect {...{
      classNamePrefix: 'react-select',
      styles: { container: base => ({ ...base, minWidth: '200px' }) },
      ...props
    }} />
  )
}

export default Select
